























































































































































































































































































import AddDomainDialog from "@/components/AddDomainDialog.vue";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { DomainHttp } from "@/mixins/http/domain";
// eslint-disable-next-line no-unused-vars
import { Domain } from "@/types/domain";
import ConfirmDeleteDialog from "@/components/ConfirmDeleteDialog.vue";
import { toDomain, toNotificationGroup } from "@/utils";
// eslint-disable-next-line no-unused-vars
import { AxiosResponse } from "axios";
import PageHeader from "@/components/PageHeader.vue";
import PageBodyVue from "@/components/PageBody.vue";
// eslint-disable-next-line no-unused-vars
import { HttpErrorHandler } from "@/mixins/error-handling";
import DateUtils from "@/utils/dayjs";
// eslint-disable-next-line no-unused-vars
import { NotificationGroup } from "@/types/notification";
import { NotificationHttp } from "@/mixins/http/notification";

@Component({
	components: {
		"page-header": PageHeader,
		"add-domain-dialog": AddDomainDialog,
		"confirm-delete-dialog": ConfirmDeleteDialog,
		"page-body": PageBodyVue,
	},
})
export default class DomainsList extends Mixins(
	DomainHttp,
	HttpErrorHandler,
	DateUtils,
	NotificationHttp
) {
	private domains: Array<Domain> = [];
	public filteredDomains: Array<Domain> = [];
	private loading: boolean = false;
	public showAddDomainDialog: boolean = false;
	public trackingError: string = "";
	public selectedDomainColumns: Array<string> = [];
	groups: NotificationGroup[] = [];

	sortingByDomainAsc: boolean = false;
	sortingByDaysLeftAsc: boolean = false;
	sortingBySslExpAsc: boolean = false;

	mounted() {
		this.getDomainsFromApi();
		this.getGroups().then((response: AxiosResponse) => {
			this.groups = response.data;
		});
		this.selectedDomainColumns = this.getDomainColumnsFromLocalStorage();
	}

	getDomainColumnsFromLocalStorage(): Array<string> {
		if (localStorage.getItem("domainsTableColumns")) {
			return localStorage.getItem("domainsTableColumns")!.split(",");
		} else {
			let defaults = ["Days Left", "Domain", "SSL Expiration", "Actions"];
			localStorage.setItem("domainsTableColumns", defaults.toString());
			return defaults;
		}
	}

	deleteDomainFromApi(domainToDelete: Domain): void {
		this.deleteDomain(domainToDelete)
			.then(() => this.getDomainsFromApi())
			.catch((error) => this.handleTokenExpired(error.response.data.message));
	}

	sortByDomainAsc(): void {
		this.sortingByDomainAsc = true;

		this.filteredDomains = this.filteredDomains.sort((domainA, domainB) => {
			if (!domainA.hostname && !domainB.hostname) return 0;
			else if (!domainA.hostname) return 1;
			else if (!domainB.hostname) return -1;
			else if (domainA.hostname.toLowerCase() < domainB.hostname.toLowerCase()) return -1;
			else if (domainA.hostname.toLowerCase() > domainB.hostname.toLowerCase()) return 1;
			else return 0;
		});
	}

	sortByDomainDesc(): void {
		this.sortingByDomainAsc = false;

		this.filteredDomains = this.filteredDomains.sort((domainA, domainB) => {
			if (!domainA.hostname && !domainB.hostname) return 0;
			else if (!domainA.hostname) return -1;
			else if (!domainB.hostname) return 1;
			else if (domainA.hostname.toLowerCase() < domainB.hostname.toLowerCase()) return 1;
			else if (domainA.hostname.toLowerCase() > domainB.hostname.toLowerCase()) return -1;
			else return 0;
		});
	}

	getDomainsFromApi() {
		this.loading = true;
		this.getDomains()
			.then((response: AxiosResponse<any>) => this.addApiResponseToDomains(response))
			.catch((error: any) => this.handleTokenExpired(error.response.data.message))
			.finally(() => (this.loading = false));
	}

	private addApiResponseToDomains(response: AxiosResponse<any>): void {
		this.domains = [];
		response.data.forEach((apiDomain: any) => {
			let domain = toDomain(apiDomain);
			if (domain) {
				this.domains.push(domain);
			}
		});

		this.filteredDomains = this.domains;
	}

	public filterDomains(searchQuery: string): void {
		this.filteredDomains = this.domains.filter((domain) => {
			if (domain.hostname) {
				return domain.hostname.toUpperCase().includes(searchQuery.toUpperCase());
			} else return false;
		});
	}

	public addDomainToTrack(trackingConfig: any): void {
		let domainDTO: any = {
			hostname: trackingConfig.hostname,
			groupIds: trackingConfig.groupIds,
		};

		this.postDomain(domainDTO)
			.then((response: AxiosResponse) => {
				this.domains.push(toDomain(response.data) as Domain);

				if (this.groups.length <= 0 && this.domains.length <= 1) {
					let autoCreatedGroup: NotificationGroup = {
						recipientEmailAddresses: [this.$store.getters["account/currentUser"].email],
						domainIdsToBeNotifiedAbout: [response.data._id],
						eventsToBeNotifiedAbout: ["ssl_update", "expiry_date"],
					};

					this.createGroup(autoCreatedGroup).then((response: AxiosResponse) => {
						this.groups.push(toNotificationGroup(response));
					});
				}
			})
			.catch((error: any) => {
				let errorMessage = error.response.data.message;

				this.handleTokenExpired(errorMessage);
				if (errorMessage == "Could not find this host") {
					this.trackingError = "Could not find " + trackingConfig.hostname;
				} else {
					this.trackingError = errorMessage;
				}
			});
	}

	get maxDomainsReached(): boolean {
		return this.domains.length >= this.$store.getters["account/currentUser"].limits.maxDomains;
	}

	get pageSubtitle(): string {
		let maxDomains: number = this.$store.getters["account/currentUser"].limits.maxDomains;
		let usedSoFar: number = this.domains.length;
		let leftOver: number = maxDomains - usedSoFar;
		return leftOver + " of " + maxDomains + " left";
	}

	isHealthy(domain: Domain): boolean {
		let hasErrors: boolean = false;
		if (domain.sslCertificates) {
			domain.sslCertificates.forEach((certificate) => {
				if (certificate.errors && certificate.errors.length > 0) {
					hasErrors = true;
				}
			});
		}

		return !hasErrors;
	}

	assignAndCalculateDaysLeft(domain: Domain): number {
		domain.sslCertificates[0].daysLeft = this.calculateDaysLeft(
			domain.sslCertificates[0]!.expires!
		);
		return domain.sslCertificates[0].daysLeft;
	}

	sortByDaysLeftAsc(): void {
		this.filteredDomains = this.filteredDomains.sort(
			(a, b) => a.sslCertificates[0]!.daysLeft! - b.sslCertificates[0]!.daysLeft!
		);
		this.sortingByDaysLeftAsc = true;
	}

	sortByDaysLeftDes(): void {
		this.filteredDomains = this.filteredDomains.sort(
			(a, b) => b.sslCertificates[0]!.daysLeft! - a.sslCertificates[0]!.daysLeft!
		);
		this.sortingByDaysLeftAsc = false;
	}

	sortBySslExpAsc(): void {
		this.filteredDomains = this.filteredDomains.sort(
			(a, b) =>
				new Date(a.sslCertificates[0]!.expires!).getTime() -
				new Date(b.sslCertificates[0]!.expires!).getTime()
		);
		this.sortingBySslExpAsc = true;
	}

	sortBySslExpDes(): void {
		this.filteredDomains = this.filteredDomains.sort(
			(a, b) =>
				new Date(b.sslCertificates[0]!.expires!).getTime() -
				new Date(a.sslCertificates[0]!.expires!).getTime()
		);
		this.sortingBySslExpAsc = false;
	}

	@Watch("selectedDomainColumns") domainColumnsChanged(newVal: Array<string>) {
		localStorage.setItem("domainsTableColumns", newVal.toString());
	}
}
